import {createSlice} from '@reduxjs/toolkit';
import {
	SET_PROJECT_PAYLOAD,
	SET_PRIMARY_CODE,
	LINK_ENGAGEMENT_CODE,
	UNLINK_ENGAGEMENT_CODE
} from './ActionCreators';
import {CLEAR_PROJECT, REMOVE_ADDED_ENGAGEMENT_CODE, REMOVE_EXISTING_ENGAGEMENT_CODE} from '../../../projects';

const initialState = {
	projectName: null,
	canvasEngagements: [],
	users: [],
	financialCodes: [],
	unvalidatedFinancialCodes: [],
	associationIncluded: false
};

export const projectPayload = createSlice({
	name: 'projectPayload',
	initialState,
	extraReducers: (builder) => {
		builder
			.addCase(SET_PROJECT_PAYLOAD, (state, action) => {
				state.projectName = action.payload.projectName;
				state.canvasEngagements = action.payload.canvasEngagements;
				state.users = action.payload.users;
				state.financialCodes = action.payload.financialCodes;
				state.unvalidatedFinancialCodes =
					action.payload.unvalidatedFinancialCodes;
				state.associationIncluded = action.payload.associationIncluded;
			})
			.addCase(SET_PRIMARY_CODE, (state, action) => {
				const canvasEngagements = state.canvasEngagements.map((engagement) => {
					const found = action.payload.canvasEngagements.find(
						(item) => item.canvasEngagementId === engagement.canvasEngagementId
					);

					const financialEngagements = [];

					financialEngagements.push(
						...engagement.financialEngagements.filter((item) => !item.isPrimary)
					);

					if (found && found.primaryCode) {
						financialEngagements.push({
							financialEngagementId: found.primaryCode,
							isPrimary: true
						});
					}

					return {
						canvasEngagementId: engagement.canvasEngagementId,
						financialEngagements
					};
				});

				state.canvasEngagements = canvasEngagements;
			})
			.addCase(LINK_ENGAGEMENT_CODE, (state, action) => {
				const canvasEngagementId = action.payload.canvasEngagementId;
				const financialEngagementId = action.payload.financialEngagementId;

				const canvasEngagements = state.canvasEngagements.map((engagement) => {
					if (engagement.canvasEngagementId !== canvasEngagementId) {
						return engagement;
					}

					const found = engagement.financialEngagements.find(
						(item) => item.financialEngagementId === financialEngagementId
					);

					if (found) {
						return engagement;
					}

					const financialEngagements = [
						...engagement.financialEngagements,
						{
							financialEngagementId,
							isPrimary: false
						}
					];

					return {
						canvasEngagementId,
						financialEngagements
					};
				});

				state.canvasEngagements = canvasEngagements;
			})
			.addCase(UNLINK_ENGAGEMENT_CODE, (state, action) => {
				const canvasEngagementId = action.payload.canvasEngagementId;
				const financialEngagementId = action.payload.financialEngagementId;

				const canvasEngagements = state.canvasEngagements.map((engagement) => {
					if (engagement.canvasEngagementId !== canvasEngagementId) {
						return engagement;
					}

					return {
						canvasEngagementId,
						financialEngagements: engagement.financialEngagements.filter(
							(item) => item.financialEngagementId !== financialEngagementId
						)
					};
				});

				state.canvasEngagements = canvasEngagements;
			})
			.addCase(CLEAR_PROJECT, (state, action) => {
				state.projectName = initialState.projectName;
				state.canvasEngagements = initialState.canvasEngagements;
				state.users = initialState.users;
				state.financialCodes = initialState.financialCodes;
				state.unvalidatedFinancialCodes =
					initialState.unvalidatedFinancialCodes;
				state.associationIncluded = false;
			})
			.addCase(REMOVE_EXISTING_ENGAGEMENT_CODE, (state, action) => {
				state.financialCodes = state.financialCodes.filter(
					(financialCodeObj) => financialCodeObj.financialCode !== action.engagementCode
				)
			})
			.addCase(REMOVE_ADDED_ENGAGEMENT_CODE, (state, action) => {
				state.canvasEngagements.forEach((canvasEng) => {
					canvasEng.financialEngagements = canvasEng.financialEngagements.filter(
						(financialCodeObj) => financialCodeObj.financialEngagementId !== action.engagementCode
					);
				});
				state.financialCodes = state.financialCodes.filter(
					(financialCodeObj) => financialCodeObj.financialCode !== action.engagementCode
				)
			});
	}
});
